import * as React from "react";
import {Helmet} from "react-helmet";
import BreadcrumbsBlock from "../layouts/breadcrumbs-block/breadcrumbs-block";
import CookieStatuteBlock from "../layouts/statute-block/cookies-statute-block";
import {PageType} from "../models/types";
import * as helmetData from "../constants/helmet-data";
import * as cacheBustingService from "../services/cache-busting-service";

interface CookiesPageProps {}

interface CookiesPageState {}

class CookiesPage extends React.Component<CookiesPageProps,CookiesPageState> {

  componentDidMount() {
    cacheBustingService.handleCacheBusting(caches);
  }

  render() {
    return (
      <div>
        <Helmet {...helmetData.prepareHelmetData(PageType.CookiesPage)}/>

        <BreadcrumbsBlock
          breadcrumbsElement={
            {
              elementName: "PLIKI COOKIES",
              elementDescription: ""
            }
          }
        />
        <CookieStatuteBlock/>
      </div>
    )
  }

}

export default CookiesPage


// WEBPACK FOOTER //
// ./src/pages/cookies.tsx